import { Component, ElementRef, Input } from "@angular/core";
import { MagicMarkdownService } from "../markdown/magic-markdown.service";

@Component( {
    selector: "magic-card-mana-cost",
    imports: [],
    template: ""
})
export class MagicCardManaCostComponent {
    @Input({required: true}) manaCost!: string;

    constructor(private selfRef: ElementRef, private magicMarkdown: MagicMarkdownService) {

    }

    public ngOnInit() {
        this.selfRef.nativeElement.innerHTML = this.magicMarkdown.formatText(this.manaCost);
    }
}